/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_OpenInputs */



/**
* | output |
* | --- |
* | "Open" |
*
* @param {Manual_Qc_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_open = /** @type {((inputs?: Manual_Qc_Status_OpenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_OpenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvert")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aprire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abierto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खुला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir")
	return /** @type {LocalizedString} */ ("Open")
});